import React from "react";
import { Box, Typography, Stack, Chip } from "@mui/joy";
import { ReactComponent as PhoneIcon } from "../../assets/svgs/phoneIcon.svg";
import { ReactComponent as IdIcon } from "../../assets/svgs/idIcon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svgs/greyCalendar.svg";
import { ReactComponent as ZipIcon } from "../../assets/svgs/locationIcon.svg";
import { Business, Work } from "@mui/icons-material";

interface Props {
  name: string;
  userId: string;
  phone: string;
  postcode: string;
  createdAt: string;
  superApplied?: boolean;
  downloadButton?: React.ReactNode;
  employerName?: string;
  positionName?: string;
}

const UserInfo: React.FC<Props> = ({
  name,
  userId,
  phone,
  postcode,
  createdAt,
  superApplied,
  downloadButton,
  employerName,
  positionName,
}) => {
  return (
    <Stack spacing={1}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography level="modalHeading">{name}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {downloadButton}
          {superApplied && <Chip>Super apply</Chip>}
        </Box>
      </Box>
      <Typography level="description" startDecorator={<IdIcon />}>
        {userId}
      </Typography>
      <Typography level="description" startDecorator={<PhoneIcon />}>
        {phone}
      </Typography>
      <Typography level="description" startDecorator={<ZipIcon />}>
        {postcode}
      </Typography>
      <Typography level="description" startDecorator={<CalendarIcon />}>
        {createdAt}
      </Typography>
      {employerName && (
        <Typography level="description" startDecorator={<Business sx={{ fontSize: '22px', mx: '1px' }} />}>
          {employerName}
        </Typography>
      )}
      {positionName && (
        <Typography level="description" startDecorator={<Work sx={{ fontSize: '22px', mx: '1px' }}/>}>
          {positionName}
        </Typography>
      )}
    </Stack>
  );
};

export default UserInfo;
